import * as React from 'react';
import {Fragment} from 'react';
import {BulkDeleteWithConfirmButton, Filter, SearchInput} from 'react-admin';
import {List, Datagrid, TextField, DateField} from 'react-admin';
import {OperationShow} from './operation.show.component';

const OperationBulkActionButtons = (props: any) => {
  const [selectedIds, setSelectedIds] = React.useState(props.selectedIds);

  React.useEffect(() => {
    setSelectedIds(props.selectedIds);
  }, [props.selectedIds, selectedIds]);

  return (
    <Fragment>
      <BulkDeleteWithConfirmButton {...props} />
    </Fragment>
  );
};

const OperationFilter = props => {
  return (
    <Filter {...props}>
      <SearchInput variant={'standard'} source="q" alwaysOn resettable />
    </Filter>
  );
};

export const OperationList = () => {
  return (
    <List
      sort={{field: 'updatedAt', order: 'DESC'}}
      exporter={false}
      filters={<OperationFilter />}
      children={
        <Datagrid
          className="oddRow"
          bulkActionButtons={<OperationBulkActionButtons />}
          expand={OperationShow}
          sx={{
            '& .column-reference': {
              whiteSpace: 'nowrap',
              width: '1%',
            },
            '& .column-createdAt, & .column-updatedAt': {
              whiteSpace: 'nowrap',
              width: '1%',
            },
          }}>
          <TextField source="reference" label="Id" />
          <TextField source="title" label="Arbetstillstånd" />
          <DateField source="createdAt" sortByOrder="DESC" options={{day: '2-digit', month: 'short', year: 'numeric'}} />
          <DateField
            source="updatedAt"
            label="Uppdaterad"
            sortByOrder="DESC"
            options={{day: '2-digit', month: 'short', year: 'numeric'}}
          />
        </Datagrid>
      }
    />
  );
};
